/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getOccupationTable = params => {
  return axios.post(`${base}/occupation/query`, params)
}
export const getOccupationDetail = params => {
  return axios.get(`${base}/occupation/get_${params.id}`, {params})
}
export const exportOccupationData = params => {
  return axios.get(`${base}/exportOccupationData/${params.id}`, {params})
}
export const createOccupationData = params => {
  return axios.post(`${base}/occupation/create`, params)
}
export const updateOccupationData = params => {
  return axios.post(`${base}/occupation/edit_${params.id}`, params)
}
export const deleteOccupationData = params => {
  return axios.post(`${base}/deleteOccupationData/${params.id}`, params)
}
export const deleteOccupationUser = params => {
  return axios.post(`${base}/occupation/remove_user_${params.id}_${params.userid}`, params)
}
export const addOccupationUser = params => {
  return axios.post(`${base}/occupation/add_user_${params.id}_${params.userid}`, params)
}
export const getOccupationUserList = params => {
  return axios.post(`${base}/occupation/query_user`, params)
}
export const uploadOccupationFile = (params, config) => {
  return axios.post(`${base}/occupation/uploadfile`, params, config)
}



// WEBPACK FOOTER //
// ./src/views/occupation/occupation.api.js